/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_sections/CardImage.js
 * Created:       Tue Jan 07 2025
 * Modified By:   Greg Olive
 * Last Modified: Tue Dec 16 2025
 */

import React, { useState, useEffect, useContext, useLayoutEffect } from 'react';
import { Tabs, ImageRadio, Legend, FormSection, LoadingSpinner } from "@proxy/_components";
import { FormContext, TranslationsContext } from '@proxy/_contexts';
import { atvImg} from "@root/_utils";

export default function CardImage() {

  const translations = useContext(TranslationsContext);

  const {
    settings,
    formData,
    currentStep,
    updateFormField,
    fulfillmentType
  }  = useContext(FormContext);


  const [tabIndex, setTabIndex] = useState(formData.fields._gcp_helper_tabIndex);
  const [imgCategories, setImgCategories] = useState([]);

  const categories = settings[fulfillmentType].greeting_card.categories
  const selectedImages = settings[fulfillmentType].greeting_card.selected_images;

  useEffect(() => {
    const categoriesToRender = selectedImages
      .filter((c) => c.images && c.images.length && categories.includes(c.name))
      .sort((a, b) => categories.indexOf(a.name) - categories.indexOf(b.name));
    setImgCategories(categoriesToRender);
  }, [categories, selectedImages]);

  const adjustHeight = () => {

    const activeTab = document.querySelector(".gc__tab_content_active");
    const tabContentWrap = document.querySelector(".gc__giftcard_selection_div");
    const navigationWrap = document.querySelector(".gc__tab_navigation");
    const navigationHeight = navigationWrap && navigationWrap.offSetHeight ? navigationWrap.offsetHeight : 50;
    const contentHeight = activeTab && activeTab.offSetHeight ? activeTab.offsetHeight : 500;
    const totalHeight =  navigationHeight + contentHeight + 30;// Total height, plus a bit of wiggle room

    if (settings.global.appearance.form_theme === "classic" && tabContentWrap) {
      tabContentWrap.style.height = totalHeight + "px";
      tabContentWrap.style["min-height"] = totalHeight + "px";
    }

  };

  useEffect(() => {

    // adjustHeight();
    atvImg();

    // setTimeout(adjustHeight, 100);

  }, [tabIndex, currentStep]);

  useLayoutEffect(() => {

    if (settings.global.appearance.form_theme === "classic") {
      // adjustHeight();
      atvImg();
    }

  }, []);

  return (
    <FormSection
      id="gcpGreetingCardSection"
      additionalClasses="gc__greeting-card-section"
      title={translations.greeting_card_image_heading}
    >
      <div className={"gc__giftcard_selection_div"}>
        <Tabs
          items={imgCategories.map((category, index) => {
            return {
              title: category.name,
              content: (
                <ImageRadio
                  key={`gc__image_radio_${index}${category.name}`}
                  images={category.images}
                  category={category.name}
                  inputName="properties[_gcp_selected_card_image]"
                  onChange={value => {
                    updateFormField("properties._gcp_selected_card_image", value);
                  }}
                  value={formData.properties._gcp_selected_card_image || ""}
                />
              )
            }
          })}
          tabIndex={tabIndex}
          setTabIndex={(value) => {
            setTabIndex(value)
            updateFormField("fields._gcp_helper_tabIndex", value);
          }}
        />
      </div>
    </FormSection>
  );
};
